<section>
    <div class="login_content">
        <div class="arrow"><button (click)="resetNewUserStatus()"><img src="assets/help/arrow.svg" alt=""></button></div>
        <div class="title">
            <h1>Sign up</h1>
            <div class="blue_line"></div>
        </div>

        <form (ngSubmit)="onCreateNewUser(signUpForm)" #signUpForm="ngForm">
            <div class="label_wrapper">
                <label class="input_content">
                    <input type="fullname" [(ngModel)]="signUp.fullname" name="fullname" [placeholder]="'Name'" #fullname="ngModel"
                    [ngClass]="{'input-error': fullname.invalid && fullname.touched}" required minlength="4">
                    <img src="./assets/contact/person.svg" alt="person">
                </label>
                @if (fullname.invalid && fullname.touched || !fullname.touched && isFormSubmitted) {
                    <p class="error-color">Please enter your name and last name.</p>
                    }
            </div>
            <div class="label_wrapper">
                <label class="input_content">
                    <input type="email" [(ngModel)]="signUp.email" name="email" [placeholder]="'Email'" #email="ngModel"
                        [ngClass]="{'input-error': email.invalid && email.touched}" required
                        pattern="[a-z0-9._%+\-]+@[a-z0-9\-]+\.[a-z]{2,}$" minlength="4">
                    <img src="./assets/contact/mail.svg" alt="mail">
                </label>
                @if (email.invalid && email.touched || !email.touched && isFormSubmitted) {
                    <p class="error-color">Check our email and password. Please try again.</p>
                    }
            </div>
            <div class="label_wrapper">
                <label class="input_content">
                    <input [type]="passwordVisible ? 'text' : 'password'" [(ngModel)]="signUp.password" name="password"
                        [placeholder]="'Password'" #password="ngModel" (input)="passwordTyped = true"
                        [ngClass]="{'input-error': password.invalid && password.touched}" required minlength="6">
                    <img [src]="passwordVisible ? './assets/login/visibility.svg' : (passwordTyped ? './assets/login/visibility_off.svg' : './assets/login/lock.svg')"
                        alt="toggle visibility" (click)="togglePasswordVisibility()">
                </label>
                @if (signUp.password.length < 6 && password.touched || !password.touched && isFormSubmitted) {
                    <p class="error-color">The password needs to have at least 6 characters</p>
                    }
            </div>
            <div class="label_wrapper">
                <label class="input_content">
                    <input [type]="confirmedPasswordVisible ? 'text' : 'password'" [(ngModel)]="signUp.confirmedPassword" name="confirmedPassword"
                        [placeholder]="'Confirm Password'" #confirmedPassword="ngModel" (input)="confirmedPasswordTyped = true"
                        [ngClass]="{'input-error': confirmedPassword.invalid && confirmedPassword.touched}" required minlength="6">
                    <img [src]="confirmedPasswordVisible ? './assets/login/visibility.svg' : (confirmedPasswordTyped ? './assets/login/visibility_off.svg' : './assets/login/lock.svg')"
                        alt="toggle visibility" (click)="toggleConfirmedPasswordVisibility()">
                </label>
                @if (confirmedPassword.touched && !confirmedPassword.valid || confirmedPassword.touched && signUp.confirmedPassword !== signUp.password) {
                    <p class="error-color">Your passwords don't match. Please try again.</p>
                } @else if (!confirmedPassword.touched && isFormSubmitted) {
                    <p class="error-color">Please enter your password again.</p>
                }
            </div>
            <div class="privacy_policy_box">
                <div class="privacy_policy_wrapper">
                    <img (click)="setPrivacyPolicy()" [src]="isPrivacyPolicyAccepted? './assets/tasks/checkbox-checked.svg' : './assets/tasks/checkbox-unchecked.svg' " alt="">
                    <p>I accept the <a routerLink="privacy-policy">Privacy policy</a></p>
                </div>
                @if(!isPrivacyPolicyAccepted && isFormSubmitted) {
                    <p class="error_p">Please accept the privacy policy </p>
                }
            </div>
            <div class="btn_content">
                <button class="dark_btn" type="submit">Sign Up</button>
            </div>
        </form>
    </div>

    <div class="imprint_content">
        <a (click)="navigateToImprint()">Legal notice</a>
        <a (click)="navigateToPrivacyPolicy()">Privacy Policy</a>
    </div>
</section>
<div class="btn_plain_color report" [ngClass] = "{ 'show_report' : newUserAdded }">
    <span>User succesfully created. Redirecting to log in.</span>
</div>

<div class="btn_plain_color report" [ngClass] = "{ 'show_report' : existingUser }">
    <span>User already exists. Please go to login</span>
</div>